import styled from 'styled-components';

export const TableHead = styled.div`
  background-color: ${(props) => props.theme.$gray200};
  color: ${(props) => props.theme.$gray700};
  font-weight: bold;
`;

export const Container = styled.div`
  @media only screen and (max-width: 768px) {
    .table-card-responsive {
      display: block;
      border: 0;
      position: relative;
      padding: 0.5em 0.5em 0.5em 30%;

      &:before {
        content: attr(data-title);
        position: absolute;
        top: 0.5em;
        left: 0.5em;
        width: 45%;
        white-space: nowrap;
        font-weight: bold;
      }

      &.no-data-title {
        padding: 0.5em;
      }
    }
  }
`;
